<template>
	<div class="main" v-loading="list_loading">
		<el-row class="searchClass">
			<el-col :span="2">设备编号</el-col>
			<el-col :span="6"><el-input v-model="deviceSid" placeholder="请输入设备编号"></el-input></el-col>
			<el-col :span="2"><el-button type="primary" @click="handleQuery">搜索</el-button></el-col>
		</el-row>
		<el-row class="add-btn"><el-button type="primary" style="margin-right:40px;" @click="add_dv1 = true">绑定</el-button></el-row>
		<el-table :data="bindList" border style="width: 100%">
			<el-table-column prop="deviceSid" label="设备编号"></el-table-column>
			<el-table-column prop="platform.name" label="平台名称"></el-table-column>
			<el-table-column prop="platform.ip" label="Ip地址"></el-table-column>
			<el-table-column prop="platform.host" label="端口号"></el-table-column>
			<el-table-column prop="platform.areaName" label="所在地市"></el-table-column>
			<el-table-column label="操作">
				<template slot-scope="scope">
					<el-button size="mini" type="warning" @click="handleEdit(scope.row)" icon="el-icon-edit">编辑</el-button>
					<el-button size="mini" type="danger" @click="handleDelete(scope.row)" icon="el-icon-delete">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div class="block">
			<el-pagination
				@current-change="handleCurrentChange"
				:current-page="currentPage"
				background
				@size-change="handleSizeChange"
				:page-sizes="[5, 10, 20]"
				:page-size="pageSize"
				layout="sizes,prev, pager, next,total,jumper"
				:total="total"
			></el-pagination>
		</div>
		<!-- 编辑平台列表 -->
		<el-dialog title="编辑平台列表" :visible.sync="add_dv" width="30%">
			<add-plat ref="addbindListForm"></add-plat>
			<span slot="footer" class="dialog-footer">
				<el-button @click="add_dv = false">取 消</el-button>
				<el-button type="primary" @click="addUser">确 定</el-button>
			</span>
		</el-dialog>
		<!-- 添加平台列表 -->
		<el-dialog title="绑定设备" :visible.sync="add_dv1" width="30%" @close="clearAddModel">
			<add ref="addbindListForm1"></add>
			<span slot="footer" class="dialog-footer">
				<el-button @click="add_dv1 = false">取 消</el-button>
				<el-button type="primary" @click="addUser1">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import addPlat from './plat-detail/add_plat.vue';
import add from './plat-detail/add.vue';

export default {
	components: {
		addPlat,
		add
	},
	inject: ['reload'],
	data() {
		return {
			deviceSid: '',
			detail_dv: false,
			detail_loading: false,
			dialogUserInfo: [],
			add_dv: false,
			add_dv1: false,
			total: 0, //总页数
			pageSize: 10, //每页条数
			currentPage: 1, //当前页（默认第一页）
			bindList: [],
			list_loading: true
		};
	},
	watch: {
		pageTotal() {
			if (this.total == (this.currentPage - 1) * this.pageSize && this.total != 0) {
				this.currentPage -= 1;
				this.getBindList(); //获取列表数据
			}
		}
	},
	// computed: {
	// 	// 模糊搜索
	// 	tables() {
	// 		const search = this.search;
	// 		if (search) {
	// 			return this.bindList.filter(data => {
	// 				return Object.keys(data).some(key => {
	// 					return (
	// 						String(data[key])
	// 							.toLowerCase()
	// 							.indexOf(search) > -1
	// 					);
	// 				});
	// 			});
	// 		}
	// 		// 当不查询时的数据bindList
	// 		return this.bindList;
	// 	}
	// },

	created() {
		this.getBindList();
	},
	methods: {
		handleCurrentChange(val) {
			this.currentPage = val; //获取当前页
			this.getBindList();
		},
		handleSizeChange(psize) {
			//选择每页条数
			this.pageSize = psize;
			this.getBindList();
		},
		/* 查询 */
		handleQuery() {
			this.pageSize = 10;
			this.currentPage = 1;
			this.getBindList();
		},
		getBindList() {
			//获取数据
			// const data = {
			// 	length: this.pageSize,
			// 	start: (this.currentPage - 1) * this.pageSize
			// }
			let data = new FormData();
			data.append('length', this.pageSize);
			data.append('start', (this.currentPage - 1) * this.pageSize);
			data.append('deviceSid', this.deviceSid);

			this.$post('api/platform/listBindInfo', data)
				.then(res => {
					this.bindList = res.data;
					this.total = res.recordsFiltered;
					this.list_loading = false;
				})
				.catch(e => {
					window.console.log(e);
				});
		},

		handleDelete(row) {
			//删除
			let data = new FormData();
			data.append('id', row.id);

			this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$post('api/platform/deleteBindInfo', data)
					.then(res => {
						let totalPage = Math.ceil((this.total - 1) / this.pageSize);
						let currentPage = this.currentPage > totalPage ? totalPage : this.currentPage;
						this.currentPage = currentPage < 1 ? 1 : currentPage;

						var isSuccess = res.success;
						if (isSuccess == 1) {
							this.$message({
								type: 'success',
								message: res.message
							});
							this.getBindList();
						} else {
							this.$message({
								type: 'error',
								message: res.message
							});
						}
					})
					.catch(e => {
						window.console.log(e);
					});
			});
		},

		handleEdit(row) {
			//编辑
			this.isEdit = true;
			this.add_dv = true;
			this.$nextTick(() => {
				//不用走接口获取table里的内容
				this.$refs.addbindListForm.form = Object.assign({}, row);
			});
		},
		addUser() {
			//编辑确定
			this.$refs.addbindListForm.$refs.frmAdd.validate(valid => {
				if (valid) {
					let data = new FormData();
					data.append('id', this.$refs.addbindListForm.form.id);
					data.append('platformId', this.$refs.addbindListForm.form.platform.id);
					data.append('deviceSid', this.$refs.addbindListForm.form.deviceSid);

					this.$post('api/platform/updateBindInfo', data)
						.then(res => {
							var isSuccess = res.success;
							if (isSuccess == 1) {
								this.$message({
									message: res.message,
									type: 'success'
								});
								this.getBindList();
							} else {
								this.$message({
									message: res.message,
									type: 'error'
								});
							}
							this.add_dv = false;
						})
						.catch(e => {
							window.console.log(e);
						});
				} else {
					return this.$message({
						message: '请完整填写信息！',
						type: 'warn'
					});
				}
			});
		},
		addUser1() {
			//绑定设备确定
			this.$refs.addbindListForm1.$refs.frmAdd.validate(valid => {
				if (valid) {
					if (this.$refs.addbindListForm1.form.value == undefined) {
						return this.$message({
							message: '请选择平台名称',
							type: 'error'
						});
					} else if (this.$refs.addbindListForm1.form.deviceSid == undefined) {
						return this.$message({
							message: '请输入设备编号',
							type: 'error'
						});
					}
					let data = new FormData();
					data.append('platformId', this.$refs.addbindListForm1.form.value);
					data.append('deviceSid', this.$refs.addbindListForm1.form.deviceSid);

					this.$post('/api/platform/addBindInfo', data)
						.then(res => {
							if (res.success == 1) {
								this.$message({
									message: res.message,
									type: 'success'
								});
								this.getBindList();
							} else {
								this.$message({
									message: res.message,
									type: 'error'
								});
							}
							this.add_dv1 = false;
						})
						.catch(e => {
							window.console.log(e);
						});
				} else {
					return this.$message({
						message: '请完整填写信息！',
						type: 'warn'
					});
				}
			});
		},
		clearAddModel() {
			//返回时清空表单数据
			this.$refs.addbindListForm1.form = {
				deviceSid: ''
			};
		}
	}
};
</script>

<style scoped="scoped">
.main .searchClass {
	padding: 20px 0;
	display: flex;
	align-items: center;
}
.main .searchClass .el-col {
	text-align: center;
	font-size: 16px;
}
.add-btn {
	margin-bottom: 20px;
}

.add-btn .el-button {
	font-size: 16px;
}

.block {
	text-align: center;
	margin-top: 20px;
}

.main {
	background: #fff;
	padding: 0 20px 20px 20px;
}
</style>
